import React from 'react';
import _ from '@dh-fe/translate';
import SignUpButton from 'components/Button/SignUpButton';
import bgDesktopJpgOranum from './assets/section5_desktopOranum.jpg';
import bgDesktopWebpOranum from './assets/section5_desktopOranum.webp';
import bgMobileJpgOranum from './assets/section5_mobileOranum.jpg';
import bgMobileWebpOranum from './assets/section5_mobileOranum.webp';

interface Content {
    bg: string;
    bgMobile: string;
    bgCompress: string;
    bgMobileCompress: string;
    button: JSX.Element;
    subtitle: string;
}

const oranumContent: Content = {
    button: <SignUpButton>{_`Register Now`}</SignUpButton>,
    bg: bgDesktopJpgOranum,
    bgMobile: bgMobileJpgOranum,
    bgCompress: bgDesktopWebpOranum,
    bgMobileCompress: bgMobileWebpOranum,
    subtitle:
        _`Take your first step to financial freedom and start living the life you deserve![br] Become an Oranum Broadcaster![/br]`
            .parseBB()
            .toJSX(),
};

// eslint-disable-next-line import/prefer-default-export
export const getContent = (): Content => {
    return oranumContent;
};
